import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

interface IntegrationGuideHeaderProps {
  customerName?: string | null;
}

const IntegrationGuideHeader: React.FC<IntegrationGuideHeaderProps> = ({
  customerName,
}) => {
  const { t } = useLanguage();

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white">
      <div className="container mx-auto flex h-20 items-center justify-between px-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-4">
            <h1 className="text-xl font-bold">
              {t("integrationGuideHeader.title")}
            </h1>
            {customerName && <div className="h-6 w-px bg-black" />}
            {customerName && (
              <h1 className="text-xl font-bold">{customerName}</h1>
            )}
          </div>
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
};

export default IntegrationGuideHeader;
